/**
 * @generated SignedSource<<ef8fa2fe09f27e97bcbf14525e6d8724>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RealtimeUpdater_project$data = {
  readonly key: string;
  readonly projectId: string;
  readonly " $fragmentType": "RealtimeUpdater_project";
};
export type RealtimeUpdater_project$key = {
  readonly " $data"?: RealtimeUpdater_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"RealtimeUpdater_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RealtimeUpdater_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW",
      "path": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b0d8698d2c8ea976e6f8b130d07d96e7";

export default node;
